module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp123_7042.cbde7425.png";